import * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import { SortingDesktop } from './components/SortingDesktop';
import { SortingMobile } from './components/SortingMobile';

import * as style from './Sorting.css';
import { ISortingProps } from './types';

export const Sorting: React.FC<ISortingProps> = props => {
  return (
    <div className={style['container']}>
      <Responsive phone tablet>
        <SortingMobile {...props} />
      </Responsive>
      <Responsive desktop>
        <SortingDesktop {...props} />
      </Responsive>
    </div>
  );
};
